export default import.meta.ROLLDOWN_FILE_URL_Mr4F81nU8Y3XzR5D6fP34g